import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { Device } from '@ionic-native/device';
import { CommonModule } from '@angular/common';
import { IonicStorageModule } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation';
import { Network } from '@ionic-native/network';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Keyboard } from '@ionic-native/keyboard';
import { CallNumber } from '@ionic-native/call-number';
import { MyApp } from './app.component';
import { registerLocaleData } from '@angular/common';
import { SQLite } from '@ionic-native/sqlite';
import localePt from '@angular/common/locales/pt';

import { DevicesProvider } from '../providers/devices/devices';
import { ClienteProvider } from '../providers/cliente/cliente';
import { ProdutoProvider } from '../providers/produto/produto';
import { PedidoProvider } from '../providers/pedido/pedido';
import { FormaPgtoProvider } from '../providers/forma-pgto/forma-pgto';
import { EmpresaProvider } from '../providers/empresa/empresa';
import { DatabaseProvider } from '../providers/database/database';
import { TabelaPrecoProvider } from '../providers/tabela-preco/tabela-preco';
import { ParametroProvider } from '../providers/parametro/parametro';
import { CartaoCreditoProvider } from '../providers/cartao-credito/cartao-credito';
import { RotaProvider } from '../providers/rota/rota';
import { NfceProvider } from '../providers/nfce/nfce';
import { HttpClientModule } from '@angular/common/http';
import { PrintProvider } from '../providers/print/print';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
      scrollAssist: false
    }),
    HttpModule,
    HttpClientModule,
    CommonModule,
    IonicStorageModule.forRoot({
      name: '__mydb',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "pt-BR"
    },
    StatusBar,
    SplashScreen,
    Device,
    Geolocation,
    Network,
    Keyboard,
    CallNumber,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    DevicesProvider,
    ClienteProvider,
    ProdutoProvider,
    PedidoProvider,
    FormaPgtoProvider,
    EmpresaProvider,
    DatabaseProvider,
    ParametroProvider,
    TabelaPrecoProvider,
    SQLite,
    CartaoCreditoProvider,
    RotaProvider,
    NfceProvider,
    BluetoothSerial,
    PrintProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts